module.exports = __webpack_public_path__ + "static/media/mentors.74f1c4bb.svg";